import dayjs from 'dayjs';
const formatMonth = (month) => dayjs()
    .month(parseInt(month) - 1)
    .format('MM');
const formatYear = (year) => dayjs().year(parseInt(year)).format('YY');
export const formatExpiresAt = (expires) => {
    return `${formatMonth(expires.month)}/${formatYear(expires.year)}`;
};
